import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  tooltipWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tooltip: {
    '&&': {
      padding: 0,
      width: 12,
      height: 12,
      borderRadius: '50%',
    },
  },
}))
